module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.el, {
    tag: "component",
    attrs: {
      "label": _vm.label,
      "required": _vm.required
    }
  }, [(_vm.noForm) ? _c('span', [_vm._v(_vm._s(_vm.label) + " ")]) : _vm._e(), _vm._v(" "), _c('el-select', {
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "value-key": "value",
      "size": _vm.size
    },
    on: {
      "change": _vm.updated
    },
    model: {
      value: (_vm.formData),
      callback: function($$v) {
        _vm.formData = $$v
      },
      expression: "formData"
    }
  }, _vm._l((_vm.groups), function(group) {
    return _c('el-option-group', {
      key: group.label,
      attrs: {
        "label": group.label
      }
    }, _vm._l((group.options), function(item) {
      return _c('el-option', {
        key: item.value,
        attrs: {
          "label": item.label,
          "value": item.value
        }
      }, [_c('span', {
        style: ('float: left; width: 100%; background-color: ' + _vm.getCatColour(item.category) + ';')
      }, [_vm._v(_vm._s(item.label) + "\n            "), _c('span', {
        class: _vm.getCatIcon(item.category),
        staticStyle: {
          "float": "right",
          "color": "#8492a6",
          "margin-right": "5px",
          "font-size": "12px"
        }
      })])])
    }), 1)
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-937d2820"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/selects/SelectOrganisation.vue
// module id = 1592
// module chunks = 0